import React from "react";
import { Card } from "@mui/material";

interface VioletCardProps {
  children: React.ReactNode;
}

export const VioletCard = (props: VioletCardProps) => {
  const { children } = props;
  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        border: "0px",
        background: "#80449F 0% 0% no-repeat padding-box",
        boxShadow: "0px 3px 6px #0000001A",
        borderRadius: "16px",
        padding: "16px",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {children}
    </Card>
  );
};
